export default () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    hyphens: 'manual',
    wordWrap: 'break-word'
  }
});
